import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import Widget from '../../../../common/js/Widget.js';

export default class StartPasswordResetWidget extends Widget {

	constructor($widget) {
		super($widget);

		Form.onSubmit(this.$widget, action => {
			Ajax.rpc('/start-password-reset', {
				email: action.findField('email').val()
			}, success => {
				if (success) {
					action.$button.remove();
					action.ok('Ok. We have now sent you an email. Please click the link you find in there.');
				} else {
					action.error('Em, I did not find any user with such email address. Please check your input.');
				}
			}, error => {
				MessageUtils.error(this.$widget,
					'Oh, das hat leider grad nicht geklappt, bitte versuch es später noch einmal', error);
			});
		});
	}

}
